/**************************************************
 * Nombre:       Formulario_Lead_Comentario_Comentario.js
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {useContext, useEffect} from "react";
import {usuarioContext} from "../../App";

const Formulario_Lead_Comentario_Comentario = ({...props}) => {
    const cData = useContext(usuarioContext)


    useEffect(() => {

        if (cData.usuario) {
            props.props.setValue('usuario', cData.usuario.nombre);
            props.props.setValue('img', cData.usuario.img);
            props.props.setValue('fecha', new Date().getTime());
        }


    }, [cData])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto lineas={5} nombre={'Comentario'} dato={'comentario'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Lead_Comentario_Comentario